/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFlagUkLegacy(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width={26}
      height={13}
      viewBox='0 0 26 13'
      {...props}
    >
      <defs>
        <path id='flag-uk-legacy_svg__a' fill='#FFF' d='M0 0h30v2.6H0z' />
        <path id='flag-uk-legacy_svg__b' fill='#CF142B' d='M0 0h15v.867H0z' />
        <g id='flag-uk-legacy_svg__c'>
          <use xlinkHref='#flag-uk-legacy_svg__a' />
          <use y={1.3} xlinkHref='#flag-uk-legacy_svg__b' />
          <use x={15} y={0.433} xlinkHref='#flag-uk-legacy_svg__b' />
        </g>
      </defs>
      <path fill='#00247D' d='M0 0h26v13H0z' />
      <use
        x={-2}
        y={5.2}
        transform='rotate(26.5 13 6.5)'
        xlinkHref='#flag-uk-legacy_svg__c'
      />
      <use
        x={-2}
        y={5.2}
        transform='rotate(-26.5 13 6.5)'
        xlinkHref='#flag-uk-legacy_svg__c'
      />
      <path
        fill='#FFF'
        d='M0 4.333h10.833V0h4.334v4.333H26v4.334H15.167V13h-4.334V8.667H0z'
      />
      <path
        fill='#CF142B'
        d='M0 5.2h11.7V0h2.6v5.2H26v2.599H14.3V13h-2.6V7.799H0z'
      />
    </svg>
  );
}

export default SvgFlagUkLegacy;
